module.exports = "/fonts/vendor/@fontsource/inter/files/inter-vietnamese-500-normal.woff2?5913e4f3173c28453f7cd51adc5a3259";